import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface NavigationAccountProps {
  initials: string;
  name: string;
  role?: string;
  className?: string;
}

export const NavigationAccount: React.FC<NavigationAccountProps> = ({
  initials,
  name,
  role,
  className
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            "gap-2 rounded-full px-2 py-1.5",
            "md:bg-sky-100/90 md:hover:bg-sky-100",
            "lg:h-8 lg:bg-white lg:hover:bg-gray-50 lg:border lg:border-gray-200 lg:ring-1 lg:ring-black/10 lg:shadow-sm",
            className
          )}
          aria-label="Account menu"
        >
          <span className={cn(
            "grid size-6 place-items-center rounded-full text-[11px] font-medium",
            "md:bg-sky-200 md:text-sky-700",
            "lg:bg-gray-100 lg:text-gray-600"
          )}>
            {initials}
          </span>
          <span className="hidden sm:flex flex-col leading-tight text-left">
            <span className={cn(
              "text-[13px] font-medium",
              "md:text-gray-900",
              "lg:text-gray-700"
            )}>{name}</span>
            {role && (
              <span className={cn(
                "text-[11px]",
                "md:text-gray-500",
                "lg:text-muted-foreground"
              )}>{role}</span>
            )}
          </span>
          <ChevronDown className={cn(
            "size-4",
            "md:text-gray-500",
            "lg:text-slate-500"
          )} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem asChild>
          <a href="#">Profile</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href="#">Settings</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href="#">Sign out</a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

NavigationAccount.displayName = 'NavigationAccount';
